"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      save_plan: [],
      selCang: {},
      selGoodsDialog: false,
      goodsList: [],
      form: {},
      listQuery: {
        start: 1,
        limit: 20,
        page_num: 1
      }
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    }
  },
  mounted: function mounted() {
    this.getInfo();
    this.getGoods();
  },
  methods: {
    /**
     * 选择商品
     * @param {Object} row
     */
    selGoods: function selGoods(row) {
      this.selCang.product_name = row.product_name;
      this.selCang.img_url = row.img_url;
      this.selCang.product_id = row.id;
      this.selCang.cost_price = row.cost_price;
      this.selCang.market_price = row.market_price;
      this.selGoodsDialog = false;
    },
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/product/get_business_samples', {
        store_id: this.id
      }).then(function (res) {
        _this.save_plan = Object.values(res.list);
      });
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) this.form = {};
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 获取商品
     */
    getGoods: function getGoods() {
      var _this2 = this;
      var url = 'agentapi/product/sample_list';
      var listQuery = Object.assign(this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get(url, listQuery).then(function (res) {
        _this2.listLoading = false;
        _this2.goodsList = res.list;
        _this2.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      var params = {};
      params.plan = this.save_plan;
      params.store_id = this.id;
      console.log(params);
      this.$post('agentapi/product/save_business_samples', params).then(function (res) {
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    }
  }
};